var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.144 8.379c-.366-.21-.836-.21-1.254 0l-2.924 1.723-1.984 1.096-2.872 1.724c-.366.209-.836.209-1.254 0l-2.245-1.358a1.273 1.273 0 0 1-.627-1.097v-2.61c0-.418.21-.836.627-1.097l2.245-1.306c.366-.209.836-.209 1.254 0l2.245 1.358c.366.209.627.627.627 1.097v1.723l1.984-1.149V6.708c0-.418-.209-.836-.627-1.097L8.162 3.157c-.366-.21-.836-.21-1.253 0L2.627 5.663A1.149 1.149 0 0 0 2 6.708v4.908c0 .418.209.836.627 1.097l4.23 2.454c.365.209.835.209 1.253 0l2.872-1.67 1.984-1.15 2.872-1.67c.366-.21.836-.21 1.253 0l2.246 1.305c.365.209.626.626.626 1.096v2.611c0 .418-.208.836-.626 1.097l-2.193 1.305c-.366.21-.836.21-1.254 0l-2.245-1.305a1.273 1.273 0 0 1-.627-1.097v-1.67l-1.984 1.148v1.723c0 .418.209.836.627 1.097l4.23 2.454c.365.21.835.21 1.253 0l4.23-2.454c.365-.209.626-.627.626-1.097v-4.96c0-.418-.209-.836-.627-1.097l-4.23-2.454z",
    fill: "#4884E8",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.4b9868b3.svg";
export { ForwardRef as ReactComponent };